"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.skipMcPrefix = skipMcPrefix;
function skipMcPrefix(name) {
    return typeof name === 'string' ? name.replace(/^minecraft:/, '') : name;
}
